import React, { useEffect, useState } from "react";
import "../../admin_resources/css/admin_layout.css";
import "../../admin_resources/css/admin_common.css";
import "../../admin_resources/css/admin_style.css";
import ADMIN_HEADER from "./Admin_Header";
import axios from "axios";

const Admin_Info = () => {
  const [adminData, setAdminData] = useState(null);
  const [adminList, setAdminList] = useState([]); // 전체 관리자 목록 상태 추가
  const [filteredAdminList, setFilteredAdminList] = useState([]); // 필터링된 관리자 목록 상태 추가

  const [currentPage, setCurrentPage] = useState(1); // 현재 페이지
  const itemsPerPage = 20; // 한 페이지에 보여줄 항목 수

  const [searchTerm, setSearchTerm] = useState(""); // 검색어 상태

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 관리자 페이지`;

    const fetchAdminData = async () => {
      try {
        const response = await axios.get("/adminlist");
        const admins = response.data;

        // localStorage에서 adminId를 가져옴
        const adminId = localStorage.getItem("adminId");

        if (adminId) {
          const selectedAdmin = admins.find(
            (admin) => admin.adminId === adminId
          );
          setAdminData(selectedAdmin);
        }

        setAdminList(admins);
        setFilteredAdminList(admins); // 초기에는 전체 목록을 필터링된 목록으로 설정
      } catch (error) {
        console.error("Error fetching admins:", error);
      }
    };

    fetchAdminData();
  }, []); // 처음 한 번만 실행

  // 검색 클릭 시 필터링된 목록 업데이트
  const handleSearchClick = async (e) => {
    e.preventDefault();

    if (searchTerm.trim() === "") {
      setFilteredAdminList(adminList); // 검색어가 없으면 전체 리스트로 설정
    } else {
      const filteredAdmins = adminList.filter((admin) =>
        admin.adminName.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredAdminList(filteredAdmins); // 필터링된 목록 업데이트
    }

    setCurrentPage(1); // 검색 후 페이지를 1로 리셋
  };

  // 페이지에 표시할 항목들 계산
  const indexOfLastAdmin = currentPage * itemsPerPage;
  const indexOfFirstAdmin = indexOfLastAdmin - itemsPerPage;
  const currentAdmins = filteredAdminList.slice(
    indexOfFirstAdmin,
    indexOfLastAdmin
  );

  // 이전 페이지로 이동
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // 다음 페이지로 이동
  const handleNextPage = () => {
    const totalPages = Math.ceil(filteredAdminList.length / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  // 페이지 네비게이션 컴포넌트
  const renderPageNumbers = () => {
    const totalPages = Math.ceil(filteredAdminList.length / itemsPerPage);
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(
        <button
          key={i}
          onClick={() => setCurrentPage(i)}
          className={currentPage === i ? "active" : ""}
        >
          {i}
        </button>
      );
    }
    return pageNumbers;
  };

  // 검색어 입력 변경 핸들러
  const handleSearchTermChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // adminData가 로딩 중이거나 없으면 로딩 중 메시지 출력
  if (!adminData) {
    return <div>로딩 중...</div>;
  }

  // 수정된 정보를 서버로 전송하는 함수
  const handleSubmit = async (e) => {
    e.preventDefault();

    const confirmUpdate = window.confirm("정보를 수정하시겠습니까?");
    if (!confirmUpdate) {
      return;
    }

    try {
      const response = await axios.put(
        `/admin_update/${adminData.adminId}`,
        adminData
      );

      if (response.status === 200) {
        alert("정보가 수정되었습니다.");
        window.location.reload();
      }
    } catch (error) {
      console.error("Error updating admin:", error);
      alert("정보 수정에 실패했습니다.");
    }
  };

  // 각 관리자의 정보를 업데이트하는 함수
  const handleAdminUpdate = (adminId, field, value) => {
    // adminList에서 직접 수정
    setAdminList((prevList) =>
      prevList.map((admin) =>
        admin.adminId === adminId ? { ...admin, [field]: value } : admin
      )
    );

    // 수정된 값이 필터링된 목록에 반영되도록
    setFilteredAdminList((prevList) =>
      prevList.map((admin) =>
        admin.adminId === adminId ? { ...admin, [field]: value } : admin
      )
    );
  };

  // 관리자 목록을 서버에 한 번에 업데이트하는 함수
  const handleUpdateAdminList = async () => {
    const confirmUpdate = window.confirm("정보를 수정하시겠습니까?");
    if (!confirmUpdate) {
      return;
    }
    try {
      const response = await axios.put("/adminlist_update", adminList);

      if (response.status === 200) {
        alert("관리자 목록이 성공적으로 업데이트되었습니다.");
        window.location.reload();
      }
    } catch (error) {
      console.error("Error updating admin list:", error);
      alert("관리자 목록 업데이트에 실패했습니다.");
    }
  };
  
  const handleDeleteAdmin = async (adminId) => {
    const confirmDelete = window.confirm(`${adminId}를 정말 삭제하시겠습니까?`);
    if (!confirmDelete) return;

    try {
      // 서버로 DELETE 요청 보내기
      const response = await axios.delete(`/admin_delete/${adminId}`);

      if (response.status === 200) {
        alert(response.data); // 서버의 "회원 삭제 성공" 메시지 표시

        // 상태에서 해당 관리자 제거
        setAdminList((prevList) =>
          prevList.filter((admin) => admin.adminId !== adminId)
        );
        setFilteredAdminList((prevList) =>
          prevList.filter((admin) => admin.adminId !== adminId)
        );
      }
    } catch (error) {
      if (error.response) {
        // 서버에서 반환한 실패 메시지 표시
        alert(error.response.data);
      } else {
        // 네트워크 오류 등 예외 처리
        alert("삭제 요청 중 오류가 발생했습니다.");
      }
    }
  };

  return (
    <div>
      <ADMIN_HEADER />
      <div className="admin_info">
        <div className="path-sec">
          HOME &gt; <span className="menu1">정보수정</span> &gt;
          <span className="menu2"> 정보수정</span>
        </div>
        <table>
          <tr>
            <td>
              <div className="sec-snb">
                <h3 className="snb_tit">정보수정</h3>
                <ul className="snb_list">
                  <li className="cur">
                    <a href="/admin/admin_info">정보수정</a>
                  </li>
                  {adminData.adminSuper === "Y" && (
                    <li>
                      <a href="/admin/admin_permission">권한수정</a>
                    </li>
                  )}
                </ul>
              </div>
            </td>
            <td>
              {adminData.adminSuper === "Y" ? (
                <>
                  <div className="search-section">
                    <form onSubmit={handleSearchClick} className="infosearch">
                      <input
                        id="strsearch"
                        className="inputTxt"
                        type="text"
                        value={searchTerm}
                        onChange={handleSearchTermChange}
                        placeholder="이름을 입력하세요"
                      />
                      <button className="btn info" type="submit">
                        검색
                      </button>
                    </form>
                  </div>
                  <div className="tb_01 wr">
                    <table>
                      <thead>
                        <tr>
                          <th>아이디</th>
                          <th>이름</th>
                          <th>비밀번호</th>
                          <th>이메일</th>
                          <th>부서명</th>
                          <th>권한</th>
						  <th>삭제</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentAdmins.map((admin) => (
                          <tr key={admin.adminId}>
                            <td>{admin.adminId}</td>
                            <td>
                              <input
                                id="adminName"
                                type="text"
                                value={admin.adminName}
                                onChange={(e) =>
                                  handleAdminUpdate(
                                    admin.adminId,
                                    "adminName",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                id="adminPwd"
                                type="password"
                                value={admin.adminPwd}
                                onChange={(e) =>
                                  handleAdminUpdate(
                                    admin.adminId,
                                    "adminPwd",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                id="adminEmail"
                                type="text"
                                value={admin.adminEmail}
                                onChange={(e) =>
                                  handleAdminUpdate(
                                    admin.adminId,
                                    "adminEmail",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>
                              <select
                                id="adminDept"
                                value={admin.adminDept}
                                onChange={(e) =>
                                  handleAdminUpdate(
                                    admin.adminId,
                                    "adminDept",
                                    e.target.value
                                  )
                                }
                              >
                                <option value="IT팀">IT팀</option>
                                <option value="경영지원팀">경영지원팀</option>
                                <option value="교육관리팀">교육관리팀</option>
                                <option value="교육부">교육부</option>
                                <option value="교육연구소">교육연구소</option>
                                <option value="교재개발팀">교재개발팀</option>
                                <option value="교재관리팀">교재관리팀</option>
                                <option value="디자인팀">디자인팀</option>
                                <option value="마케팅사업부">
                                  마케팅사업부
                                </option>
                                <option value="운영팀">운영팀</option>
                                <option value="출판사업팀">출판사업팀</option>
                                <option value="콘텐츠사업팀">
                                  콘텐츠사업팀
                                </option>
                              </select>
                            </td>
                            <td>
                              <select
                                id="adminActive"
                                value={admin.adminActive}
                                onChange={(e) =>
                                  handleAdminUpdate(
                                    admin.adminId,
                                    "adminActive",
                                    e.target.value
                                  )
                                }
                              >
                                <option value="Y">Y</option>
                                <option value="N">N</option>
                              </select>
                            </td>
							<td>
							  <button
							    onClick={() => handleDeleteAdmin(admin.adminId)}
							  >
							    삭제
							  </button>
							</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="pagination">
                      <button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                      >
                        이전
                      </button>
                      {renderPageNumbers()}
                      <button
                        onClick={handleNextPage}
                        disabled={
                          currentPage ===
                          Math.ceil(filteredAdminList.length / itemsPerPage)
                        }
                      >
                        다음
                      </button>
                    </div>
                    <div className="view-btn">
                      <button
                        className="infobtn"
                        onClick={handleUpdateAdminList}
                      >
                        수정
                      </button>
                    </div>
                  </div>
                </>
              ) : null}

              {adminData.adminSuper === "N" && (
                <>
                  <div className="bx-top">가입 정보 수정</div>
                  <form id="infoform" onSubmit={handleSubmit}>
                    <div className="tb_01 wr">
                      <table>
                        <tbody>
                          <tr>
                            <th>아이디</th>
                            <td>{adminData.adminId}</td>
                          </tr>
                          <tr>
                            <th>비밀번호</th>
                            <td>
                              <input
                                name="adminPwd"
                                type="password"
                                value={adminData.adminPwd}
                                onChange={(e) =>
                                  setAdminData({
                                    ...adminData,
                                    adminPwd: e.target.value,
                                  })
                                }
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>이름</th>
                            <td>
                              <input
                                name="adminName"
                                value={adminData.adminName}
                                onChange={(e) =>
                                  setAdminData({
                                    ...adminData,
                                    adminName: e.target.value,
                                  })
                                }
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>이메일</th>
                            <td>
                              <input
                                name="adminEmail"
                                value={adminData.adminEmail}
                                onChange={(e) =>
                                  setAdminData({
                                    ...adminData,
                                    adminEmail: e.target.value,
                                  })
                                }
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>부서명</th>
                            <td>
                              <select
                                name="adminDept"
                                id="adminDept"
                                value={adminData.adminDept}
                                onChange={(e) =>
                                  setAdminData({
                                    ...adminData,
                                    adminDept: e.target.value,
                                  })
                                }
                              >
                                <option value="IT팀">IT팀</option>
                                <option value="경영지원팀">경영지원팀</option>
                                <option value="교육관리팀">교육관리팀</option>
                                <option value="교육부">교육부</option>
                                <option value="교육연구소">교육연구소</option>
                                <option value="교재개발팀">교재개발팀</option>
                                <option value="교재관리팀">교재관리팀</option>
                                <option value="디자인팀">디자인팀</option>
                                <option value="마케팅사업부">
                                  마케팅사업부
                                </option>
                                <option value="운영팀">운영팀</option>
                                <option value="출판사업팀">출판사업팀</option>
                                <option value="콘텐츠사업팀">
                                  콘텐츠사업팀
                                </option>
                              </select>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </form>
                  <div className="view-btn">
                    <button className="infobtn" type="submit" form="infoform">
                      수정
                    </button>
                  </div>
                </>
              )}
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default Admin_Info;
